<!-- 多选课程 -->
<template>
  <el-form-item>
    <template #label>
      <div class="el-form-item__label">
        <slot>{{ label }}</slot>
      </div>
    </template>
    <el-input
      :modelValue="curriculumName"
      :placeholder="config.placeholder"
      clearable
      @focus="chooseCurriculum"
      @clear="chooseCurriculum('clear')"
    ></el-input>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref, computed } from 'vue';

export default {
  kind: 'yq-课程弹窗选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '课程：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const popup = inject('popup');

    function reset() {
      courseSelectedList.value = props.value;
    }

    const courseSelectedList = useQuery('courseMulti', props.value, reset);

    if (props.value.length > 0) {
      onMounted(() => {
        courseSelectedList.value = props.value;
      });
    }

    // 选择课程
    async function chooseCurriculum(type) {
      if (type === 'clear') {
        courseSelectedList.value = [];
      } else {
        const res = await popup('base-curriculum-chooser', {
          lists: courseSelectedList.value,
        });
        courseSelectedList.value = res;
      }
    }

    // 获取课程名称
    const curriculumName = computed(() => {
      const txt = courseSelectedList.value.map((i) => i.curriculumName);
      return txt;
    });

    return {
      child,
      courseSelectedList,
      chooseCurriculum,
      curriculumName,
    };
  },
};
</script>
